module.exports = __webpack_public_path__ + "static/media/memories_6.7a8848f1.jpg";